const changePassword = {
  title: "Create",
  subTitle: "New Password",
  resetPassword: "Reset Password",
  changePassword: "Change Password",
  updatePassword: "Update Password",
  labels: {
    oldPassword: "Temp Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm new password",
  },
  placeholders: {
    oldPassword: "Enter your old password",
    tempPassword: "Enter your temp password",
    newPassword: "Enter your new password",
    confirmNewPassword: "Confirm new password",
  },
  actionBTN: "Save",
  resetPage: {
    oldPassword: "Old Password",
    newPassword: "New Password",
  },
  security: {
    title: "Security",
    companyPortalSecurity: "Security Settings",
    companyPortalSecuritySubtitle: "Manage your password and account protection methods.",  
    keepYourAccountSecure: "Keep Your Account Secure With A Strong Password"
   }
};

export default changePassword;
